/**
 * ESM browser stub for Node.js built-ins that are browser-excluded via
 * package browser field ("net": false, "http": false, etc.) and are accessed
 * as namespace objects (default import + property access).
 *
 * WHY export default {} (not undefined, not a class):
 *
 *   Node.js built-ins like `net` are imported as namespace objects:
 *     import net from 'net'  // browser exclude (comment from WebTorrent source)
 *
 *   Code then accesses properties:
 *     net.connect(host, port, cb)   // TCP — never called in browser WebRTC mode
 *     typeof net.createServer       // guard check
 *
 *   If net = undefined → accessing net.connect throws TypeError immediately.
 *   If net = {}       → net.connect = undefined (no throw on access).
 *                       Calling undefined() throws "not a function" — but only
 *                       if the guard check fails, which it never does in browser.
 *
 *   This matches what the browser field "false" mapping provides in the
 *   production Rollup build: an empty object with no properties.
 *
 * WHY ESM (not CJS module.exports = {}):
 *
 *   webtorrent/lib/torrent.js is an ES module ("type": "module").
 *   Rollup 4.x strict mode fails on CJS→ESM default interop for externalized
 *   Node core modules in the same way it fails for npm packages.
 *   A native ESM default export avoids this entirely.
 *
 * Used by:
 *   net: webtorrent/lib/torrent.js, webtorrent/lib/conn-pool.js
 */
export default {};
